






























import { listFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { SkladoveMistoPredmetu } from '@/modules/ciselnik/pujcovna/skladoveMistoPredmetu';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		SkladMistoPredmetuSelect: SkladoveMistoPredmetu.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				vstupPrac: `${this.storeUri}/${listMutations.VSTUP_PRAC_SELECT_MAPPER}`,
				skladMistoPredmetu: `${this.storeUri}/${listMutations.SKLAD_MISTO_PREDMETU_SELECT_MAPPER}`,
			};
		},
		skladMistoPredmetuFilter(): { SkladostOzn: number | null, VyrazenPrp: boolean } {
			return {
				SkladostOzn: this.SkladostOzn,
				VyrazenPrp: false,
			};
		},
	},
});
